"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const css_1 = require("../css");
const BASE_REM_SIZE = 16;
const transformToken = (name, token) => {
    const result = [];
    result.push({
        name,
        tokenType: "fontSize",
        type: "variable",
        value: `${token.fontSize.px / BASE_REM_SIZE}rem`,
    });
    result.push({
        name,
        tokenType: "lineHeight",
        type: "variable",
        value: `${token.lineHeight.px / BASE_REM_SIZE}rem`,
    });
    if (token.fontFamilyToken) {
        result.push({
            name,
            tokenType: "fontFamily",
            type: "variable",
            value: `var(${(0, css_1.getVariableName)(token.fontFamilyToken, "fontFamily")})`,
        });
    }
    if (token.fontWeightToken) {
        result.push({
            name,
            tokenType: "fontWeight",
            type: "variable",
            value: `var(${(0, css_1.getVariableName)(token.fontWeightToken, "fontWeight")})`,
        });
    }
    result.push({
        name,
        tokenType: "letterSpacing",
        type: "variable",
        value: token.letterSpacing ? `${token.letterSpacing.px}px` : "normal",
    });
    return result;
};
exports.default = transformToken;
